__webpack_require__.g = typeof globalThis === 'object' ? globalThis : window;